import React from 'react';
import { useTranslation } from 'react-i18next';
import { Construction } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const ComingSoon = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4">
      <div className="bg-orange-50 p-6 rounded-full mb-6">
        <Construction className="w-16 h-16 text-[#FF6A00]" />
      </div>
      <h1 className="text-4xl md:text-5xl font-bold text-[#0A1F44] mb-4">
        {t('common.comingSoon', 'Coming Soon')}
      </h1>
      <p className="text-xl text-gray-600 max-w-md mb-8">
        {t('common.underConstruction', 'This page is currently under construction. Please check back later.')}
      </p>
      <Link to="/">
        <Button className="bg-[#FF6A00] hover:bg-[#E55F00] text-white px-8 py-6 text-lg">
          {t('common.backHome', 'Back to Home')}
        </Button>
      </Link>
    </div>
  );
};

export default ComingSoon;
